import React from "react";
import { Link } from "react-router-dom";
import Footer, { RenderText } from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const LegalPage = ({ doc, children, showVersion = true }) => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="max-w-4xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900" data-testid="legal-home-link">
            <ArrowLeft className="w-4 h-4"/> Back to CarryIt
          </Link>
          {showVersion && doc?.version && (
            <div className="text-[11px] text-slate-400 font-mono">v{doc.version} · {doc.effective}</div>
          )}
        </div>
      </header>
      <article className="max-w-4xl mx-auto px-6 py-10" data-testid={`legal-page-${doc?.slug}`}>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">{doc?.title}</h1>
        <div className="mt-8 space-y-8 text-[15px] leading-relaxed text-slate-700">{children}</div>
        <div className="mt-12 text-xs text-slate-400 border-t border-slate-100 pt-4">
          This document is provided as a plain-English draft to guide legal review. Please consult a qualified lawyer before final use.
        </div>
      </article>
      <Footer/>
    </div>
  );
};

export const DocSections = ({ sections }) => (
  <>
    {sections.map((s, i) => (
      <section key={i}>
        <h2 className="font-display text-lg font-bold text-slate-900 mb-2">{s.heading}</h2>
        <div className="space-y-2">
          {s.body.map((p, j) => (
            <p key={j} className="whitespace-pre-line">
              <RenderText text={p}/>
            </p>
          ))}
        </div>
      </section>
    ))}
  </>
);

export default LegalPage;
